import React from 'react'

const RightNav = () => {
  return (
    <div className='nav'>
      <a>Loan Details</a>
      <a>Loan History</a>
      <a>Analysis Result</a>
    </div>
  )
}

export default RightNav